export default __webpack_public_path__ + "static/media/hero_image.0a5006f3.jpg";